module.exports = __webpack_public_path__ + "static/media/logout-color.a5e13314.svg";